export default __webpack_public_path__ + "static/media/skiing.398c1f33.svg";